import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import UploadLogs from 'components/UploadLogs'
import Heading from 'components/Heading'
import Card from 'components/Card'
import constants from 'constants'

class TaxStatementsLog extends React.Component {
  static propTypes = {
    backToAdminCentreText: PropTypes.string.isRequired,
    uploadLogs: PropTypes.object.isRequired,
  }
  static defaultProps = {

  }

  getUploadLogs = () => {
    this.props.getUploadLogs('error')
  }
  render() {
    const isCapitalLoans = (window.location.href.indexOf('uploadlogs/capitalloans') > 0)
    const { uploadLogs, backToAdminCentreText } = this.props
    if (!uploadLogs.isFetching && (uploadLogs.documents || uploadLogs.cpTrustDeeds || uploadLogs.cpLoanPack || uploadLogs.cpAmtConfirmation)) {
      return (
        <div>
          { !isCapitalLoans && <UploadLogs backToAdminCentreText={backToAdminCentreText} documentsArray={uploadLogs.documents} isAdmin={this.props.currentUser.IsAdmin} title="File Name" /> }
          { isCapitalLoans && uploadLogs.cpTrustDeeds && <div>
            <Heading noTopPadding>{constants.UPLOADLOGS.CAPITALLOANS_HEADER.TRUSTDEEDS}</Heading>
            <Card noPadding>
              <UploadLogs backToAdminCentreText={backToAdminCentreText} documentsArray={uploadLogs.cpTrustDeeds} isAdmin={this.props.currentUser.IsAdmin} title="File Name" />
            </Card>          
            </div>
          }
          { isCapitalLoans && uploadLogs.cpLoanPack && <div>
            <Heading noTopPadding>{constants.UPLOADLOGS.CAPITALLOANS_HEADER.LOANPACK}</Heading>
            <Card noPadding>
              <UploadLogs backToAdminCentreText={backToAdminCentreText} documentsArray={uploadLogs.cpLoanPack} isAdmin={this.props.currentUser.IsAdmin} title="File Name" />
            </Card>          
            </div>
          }
          { isCapitalLoans && uploadLogs.cpAmtConfirmation && <div>
            <Heading noTopPadding>{constants.UPLOADLOGS.CAPITALLOANS_HEADER.AMOUNTCONFIRMATION}</Heading>
            <Card noPadding>
              <UploadLogs backToAdminCentreText={backToAdminCentreText} documentsArray={uploadLogs.cpAmtConfirmation} isAdmin={this.props.currentUser.IsAdmin} title="File Name" />
            </Card>          
            </div>
          }
        </div>
      )
    }
    return (<Loading pageLoading />)
  }
}

export default TaxStatementsLog



// WEBPACK FOOTER //
// ./src/views/UploadLogs/UploadLogsView.js